import React, { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { toast } from "sonner";

export default function ChangePassword() {
  const { admin, refresh, checking } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (checking) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("Passwords don't match"); return; }
    if (next.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      await refresh();
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-zinc-200 rounded-md shadow-sm p-10" data-testid="change-password-page">
        <div className="font-display text-2xl tracking-tighter font-bold mb-1">LECIS<span className="text-red-600">.</span></div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-6">Admin Panel</div>
        <h1 className="font-display text-3xl tracking-tighter mb-2">Set a new password</h1>
        <p className="text-sm text-zinc-500 mb-6">{admin?.must_reset_password ? "You must change your temporary password before continuing." : "Update your password."}</p>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Current password">
            <input data-testid="cp-current" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} />
          </Field>
          <Field label="New password">
            <input data-testid="cp-new" type="password" required value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
          </Field>
          <Field label="Confirm new password">
            <input data-testid="cp-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
          </Field>
          <button data-testid="cp-submit" type="submit" disabled={loading} className="w-full h-11 bg-zinc-900 hover:bg-zinc-800 text-white font-medium text-sm tracking-wide disabled:opacity-50">
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
      </div>
    </div>
  );
}
const inputCls = "w-full h-11 px-3 border border-zinc-300 focus:border-zinc-900 focus:outline-none text-sm bg-white";
function Field({ label, children }) {
  return <div><label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold mb-2 block">{label}</label>{children}</div>;
}
